import { Component, OnInit } from '@angular/core';
import { BzgModalRef } from 'bz-genome-angular';

@Component({
  selector: 'biz-save-pending-changes',
  templateUrl: './save-pending-changes.component.html',
  styleUrls: ['./save-pending-changes.component.scss']
})
export class SavePendingChangesComponent implements OnInit {

  constructor(public modalRef: BzgModalRef) { }

  ngOnInit() {
  }

  public dispathModalAction(action: string) {
    const result = {action};
    this.modalRef.close(result);
  }

}
